// import React, { useState } from 'react';
// import { Link, useLocation } from 'react-router-dom';
// import logo from '../assets/logo.png';
// import searchIcon from '../assets/searchicon.png';
// import ServicesNavbar from './ServicesNavbar';
// import ProductsNavbar from './ProductsNavbar';
// import { FaBars, FaTimes,FaChevronDown  } from 'react-icons/fa';

// const Navbar = () => {
//     const location = useLocation();
//     const currentPath = location.pathname;
//     const [servicesDropdownOpen, setServicesDropdownOpen] = useState(false);
//     const [productsDropdownOpen, setProductsDropdownOpen] = useState(false);
//     const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

//     const toggleServicesMenu = (event) => {
//         event.preventDefault();
//         setServicesDropdownOpen(!servicesDropdownOpen);
//         setProductsDropdownOpen(false);
//     };

//     const toggleProductsMenu = (event) => {
//         event.preventDefault();
//         setProductsDropdownOpen(!productsDropdownOpen);
//         setServicesDropdownOpen(false);
//     };

//     const closeMenu = () => {
//         setServicesDropdownOpen(false);
//         setProductsDropdownOpen(false);
//         setMobileMenuOpen(false);
//     };

//     return (
//         <div className="w-full fixed bg-white shadow-[0px_4px_4px_0px_#00000040] z-50">
//             <div className="flex justify-between items-center px-4 py-3 md:px-8">
//                 {/* Logo */}
//                 <div className="flex items-center w-1/4 md:w-1/6">
//                     <img alt="logo" src={logo} className="w-[50px] h-[50px]" />
//                 </div>

//                 {/* Right section on mobile & tablet */}
//                 <div className="flex lg:hidden items-center gap-4">
//                     <img alt="search icon" src={searchIcon} className="w-[24px] h-[24px]" />
//                     {/* <button className="bg-[#006BD3] text-white px-4 py-1 rounded text-sm">Login</button> */}
//                     <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
//                         {mobileMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
//                     </button>
//                 </div>

//                 {/* Desktop Menu */}
//                 <ul className="hidden lg:flex w-3/4 justify-center items-center gap-6">
//                     <Link
//                         onClick={closeMenu}
//                         to="/"
//                         className={`pt-4 pb-1 ${currentPath === '/' ? 'text-[#2F55D4] border-b-2 border-[#2F55D4]' : 'text-black border-b-2 border-transparent'} hover:text-[#2F55D4] transition`}
//                     >
//                         Home
//                     </Link>
//                     <Link
//                         onClick={closeMenu}
//                         to="/aboutus"
//                         className={`pt-4 pb-1 ${currentPath === '/aboutus' ? 'text-[#2F55D4] border-b-2 border-[#2F55D4]' : 'text-black border-b-2 border-transparent'} hover:text-[#2F55D4] transition`}
//                     >
//                         About us
//                     </Link>
//                     <li
//     onClick={toggleServicesMenu}
//     className={`pt-4 pb-1 cursor-pointer border-b-2 ${
//         servicesDropdownOpen || currentPath.includes('/services')
//             ? 'text-[#2F55D4] border-[#2F55D4]'
//             : 'text-black border-transparent hover:text-[#2F55D4] hover:border-[#2F55D4]'
//     } transition`}
// >
//     Services
//     {servicesDropdownOpen && <ServicesNavbar />}
// </li>

// <li
//     onClick={toggleProductsMenu}
//     className={`pt-4 pb-1 cursor-pointer border-b-2 ${
//         productsDropdownOpen || currentPath.includes('/products')
//             ? 'text-[#2F55D4] border-[#2F55D4]'
//             : 'text-black border-transparent hover:text-[#2F55D4] hover:border-[#2F55D4]'
//     } transition`}
// >
//     Products
//     {productsDropdownOpen && <ProductsNavbar />}
// </li>

//                     <Link
//                         onClick={closeMenu}
//                         to="/career"
//                         className={`pt-4 pb-1 ${currentPath === '/career' ? 'text-[#2F55D4] border-b-2 border-[#2F55D4]' : 'text-black border-b-2 border-transparent'} hover:text-[#2F55D4] transition`}
//                     >
//                         Career
//                     </Link>
//                     <Link
//                         onClick={closeMenu}
//                         to="/blog"
//                         className={`pt-4 pb-1 ${currentPath === '/blog' ? 'text-[#2F55D4] border-b-2 border-[#2F55D4]' : 'text-black border-b-2 border-transparent'} hover:text-[#2F55D4] transition`}
//                     >
//                         Blog
//                     </Link>
//                     <Link
//                         onClick={closeMenu}
//                         to="/events"
//                         className={`pt-4 pb-1 ${currentPath === '/events' ? 'text-[#2F55D4] border-b-2 border-[#2F55D4]' : 'text-black border-b-2 border-transparent'} hover:text-[#2F55D4] transition`}
//                     >
//                         Events
//                     </Link>
//                     <Link
//                         onClick={closeMenu}
//                         to="/contactus"
//                         className={`pt-4 pb-1 ${currentPath === '/contactus' ? 'text-[#2F55D4] border-b-2 border-[#2F55D4]' : 'text-black border-b-2 border-transparent'} hover:text-[#2F55D4] transition`}
//                     >
//                         Contact us
//                     </Link>
//                 </ul>

//                 {/* Desktop Right Section */}
//                 <div className="hidden lg:flex w-1/6 justify-end items-center gap-4">
//                     <img alt="search icon" src={searchIcon} className="w-[24px] h-[24px]" />
//                     {/* <button className="bg-[#006BD3] text-white px-6 py-2 rounded">Login</button> */}
//                 </div>
//             </div>

//             {/* Mobile & Tablet Dropdown Menu */}
//             {mobileMenuOpen && (
//                 <div className="lg:hidden flex flex-col items-center bg-white px-6 pb-4 gap-4">
//                     <Link onClick={closeMenu} to="/" className="text-black hover:text-[#2F55D4]">Home</Link>
//                     <Link onClick={closeMenu} to="/aboutus" className="text-black hover:text-[#2F55D4]">About us</Link>
//                     <div onClick={toggleServicesMenu} className="text-black hover:text-[#2F55D4] cursor-pointer flex items-center">
//             <span>Services</span>
//             <span className="ml-2 block lg:hidden">&#9662;</span> {/* ▼ symbol */}
//           </div>
          
//           {servicesDropdownOpen && <ServicesNavbar />}
//                     <div
//     onClick={toggleProductsMenu}
//     className="text-black flex items-center justify-center w-full cursor-pointer sm:w-auto"
// >
//     <span className="hover:text-[#2F55D4]">Products</span>
    
//     {/* Show dropdown icon only on sm/md screens */}
//     <span className="ml-2 block lg:hidden">&#9662;</span> {/* ▼ symbol */}
// </div>
// {productsDropdownOpen && (
//     <div className="mt-2 bg-white shadow-md rounded px-4 py-2 w-full max-w-[300px]">
//         <ul className="list-disc pl-5 space-y-1">
//             <li>
//                 <Link
//                     onClick={closeMenu}
//                     to="/e-learn"
//                     className="text-black hover:text-[#2F55D4] transition"
//                 >
//                     Avinya E-learning Platform
//                 </Link>
//             </li>
//             <li>
//                 <Link
//                     onClick={closeMenu}
//                     to="/ngo"
//                     className="text-black hover:text-[#2F55D4] transition"
//                 >
//                     Avinya NGO App
//                 </Link>
//             </li>
//             <li>
//                 <Link
//                     onClick={closeMenu}
//                     to="/logistics"
//                     className="text-black hover:text-[#2F55D4] transition"
//                 >
//                     Esparse Logistics Software
//                 </Link>
//             </li>
//             <li>
//                 <Link
//                     onClick={closeMenu}
//                     to="/boragocarpooling"
//                     className="text-black hover:text-[#2F55D4] transition"
//                 >
//                     Bora Go Carpooling
//                 </Link>
//             </li>
//             <li>
//                 <Link
//                     onClick={closeMenu}
//                     to="/our-services"
//                     className="text-black hover:text-[#2F55D4] transition"
//                 >
//                     Industry Mentor Meetup Program
//                 </Link>
//             </li>
//             <li>
//                 <Link
//                     onClick={closeMenu}
//                     to="/esparse-logistic-solutions"
//                     className="text-black hover:text-[#2F55D4] transition"
//                 >
//                     Esparse Logistic Solutions
//                 </Link>
//             </li>
//         </ul>
//     </div>
// )}



//                     <Link onClick={closeMenu} to="/career" className="text-black hover:text-[#2F55D4]">Career</Link>
//                     <Link onClick={closeMenu} to="/blog" className="text-black hover:text-[#2F55D4]">Blog</Link>
//                     <Link onClick={closeMenu} to="/events" className="text-black hover:text-[#2F55D4]">Events</Link>
//                     <Link onClick={closeMenu} to="/contactus" className="text-black hover:text-[#2F55D4]">Contact us</Link>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default Navbar;






import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/logo.png';
import searchIcon from '../assets/searchicon.png';
import ServicesNavbar from './ServicesNavbar';
import ProductsNavbar from './ProductsNavbar';
import { FaBars, FaTimes, FaChevronDown } from 'react-icons/fa';

const Navbar = () => {
    const location = useLocation();
    const currentPath = location.pathname;
    const [servicesDropdownOpen, setServicesDropdownOpen] = useState(false);
    const [productsDropdownOpen, setProductsDropdownOpen] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const toggleServicesMenu = (event) => {
        event.preventDefault();
        setServicesDropdownOpen(!servicesDropdownOpen);
        setProductsDropdownOpen(false);
    };

    const toggleProductsMenu = (event) => {
        event.preventDefault();
        setProductsDropdownOpen(!productsDropdownOpen);
        setServicesDropdownOpen(false);
    };

    const closeMenu = () => {
        setServicesDropdownOpen(false);
        setProductsDropdownOpen(false);
        setMobileMenuOpen(false);
    };

    useEffect(() => {
        closeMenu(); // Close all dropdowns and mobile menu on route change
    }, [location.pathname]);

    return (
        <div className="w-full fixed bg-white shadow-[0px_4px_4px_0px_#00000040] z-50">
            <div className="flex justify-between items-center px-4 py-3 md:px-8">
                {/* Logo */}
                <div className="flex items-center w-1/4 md:w-1/6">
                    <img alt="logo" src={logo} className="w-[50px] h-[50px]" />
                </div>

                {/* Right section on mobile & tablet */}
                <div className="flex lg:hidden items-center gap-4">
                    <img alt="search icon" src={searchIcon} className="w-[24px] h-[24px]" />
                    <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
                        {mobileMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
                    </button>
                </div>

                {/* Desktop Menu */}
                <ul className="hidden lg:flex w-3/4 justify-center items-center gap-6">
                    <Link
                        onClick={closeMenu}
                        to="/"
                        className={`pt-4 pb-1 ${currentPath === '/' ? 'text-[#2F55D4] border-b-2 border-[#2F55D4]' : 'text-black border-b-2 border-transparent'} hover:text-[#2F55D4] transition`}
                    >
                        Home
                    </Link>
                    <Link
                        onClick={closeMenu}
                        to="/aboutus"
                        className={`pt-4 pb-1 ${currentPath === '/aboutus' ? 'text-[#2F55D4] border-b-2 border-[#2F55D4]' : 'text-black border-b-2 border-transparent'} hover:text-[#2F55D4] transition`}
                    >
                        About us
                    </Link>
                    <li
                        onClick={toggleServicesMenu}
                        className={`pt-4 pb-1 cursor-pointer border-b-2 ${
                            servicesDropdownOpen || currentPath.includes('/services')
                                ? 'text-[#2F55D4] border-[#2F55D4]'
                                : 'text-black border-transparent hover:text-[#2F55D4] hover:border-[#2F55D4]'
                        } transition`}
                    >
                        Services
                        {servicesDropdownOpen && <ServicesNavbar />}
                    </li>
                    <li
                        onClick={toggleProductsMenu}
                        className={`pt-4 pb-1 cursor-pointer border-b-2 ${
                            productsDropdownOpen || currentPath.includes('/products')
                                ? 'text-[#2F55D4] border-[#2F55D4]'
                                : 'text-black border-transparent hover:text-[#2F55D4] hover:border-[#2F55D4]'
                        } transition`}
                    >
                        Products
                        {productsDropdownOpen && <ProductsNavbar />}
                    </li>
                    <Link
                        onClick={closeMenu}
                        to="/career"
                        className={`pt-4 pb-1 ${currentPath === '/career' ? 'text-[#2F55D4] border-b-2 border-[#2F55D4]' : 'text-black border-b-2 border-transparent'} hover:text-[#2F55D4] transition`}
                    >
                        Career
                    </Link>
                    <Link
                        onClick={closeMenu}
                        to="/blog"
                        className={`pt-4 pb-1 ${currentPath === '/blog' ? 'text-[#2F55D4] border-b-2 border-[#2F55D4]' : 'text-black border-b-2 border-transparent'} hover:text-[#2F55D4] transition`}
                    >
                        Blog
                    </Link>
                    <Link
                        onClick={closeMenu}
                        to="/events"
                        className={`pt-4 pb-1 ${currentPath === '/events' ? 'text-[#2F55D4] border-b-2 border-[#2F55D4]' : 'text-black border-b-2 border-transparent'} hover:text-[#2F55D4] transition`}
                    >
                        Events
                    </Link>
                    <Link
                        onClick={closeMenu}
                        to="/contactus"
                        className={`pt-4 pb-1 ${currentPath === '/contactus' ? 'text-[#2F55D4] border-b-2 border-[#2F55D4]' : 'text-black border-b-2 border-transparent'} hover:text-[#2F55D4] transition`}
                    >
                        Contact us
                    </Link>
                </ul>

                {/* Desktop Right Section */}
                <div className="hidden lg:flex w-1/6 justify-end items-center gap-4">
                    <img alt="search icon" src={searchIcon} className="w-[24px] h-[24px]" />
                </div>
            </div>

            {/* Mobile & Tablet Dropdown Menu */}
            {mobileMenuOpen && (
                <div className="lg:hidden flex flex-col items-center bg-white px-6 pb-4 gap-4">
                    <Link onClick={closeMenu} to="/" className="text-black hover:text-[#2F55D4]">Home</Link>
                    <Link onClick={closeMenu} to="/aboutus" className="text-black hover:text-[#2F55D4]">About us</Link>

                    <div onClick={toggleServicesMenu} className="text-black hover:text-[#2F55D4] cursor-pointer flex items-center">
                        <span>Services</span>
                        <span className="ml-2 block lg:hidden">&#9662;</span>
                    </div>
                    {servicesDropdownOpen && <ServicesNavbar />}

                    <div onClick={toggleProductsMenu} className="text-black flex items-center justify-center w-full cursor-pointer sm:w-auto">
                        <span className="hover:text-[#2F55D4]">Products</span>
                        <span className="ml-2 block lg:hidden">&#9662;</span>
                    </div>
                    {productsDropdownOpen && (
                        <div className="mt-2 bg-white shadow-md rounded px-4 py-2 w-full max-w-[300px]">
                            <ul className="list-disc pl-5 space-y-1">
                                <li>
                                    <Link onClick={closeMenu} to="/e-learn" className="text-black hover:text-[#2F55D4] transition">
                                        Avinya E-learning Platform
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={closeMenu} to="/ngo" className="text-black hover:text-[#2F55D4] transition">
                                        Avinya NGO App
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={closeMenu} to="/logistics" className="text-black hover:text-[#2F55D4] transition">
                                        Esparse Logistics Software
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={closeMenu} to="/boragocarpooling" className="text-black hover:text-[#2F55D4] transition">
                                        Bora Go Carpooling
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={closeMenu} to="/our-services" className="text-black hover:text-[#2F55D4] transition">
                                        Industry Mentor Meetup Program
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={closeMenu} to="/esparse-logistic-solutions" className="text-black hover:text-[#2F55D4] transition">
                                        Esparse Logistic Solutions
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    )}

                    <Link onClick={closeMenu} to="/career" className="text-black hover:text-[#2F55D4]">Career</Link>
                    <Link onClick={closeMenu} to="/blog" className="text-black hover:text-[#2F55D4]">Blog</Link>
                    <Link onClick={closeMenu} to="/events" className="text-black hover:text-[#2F55D4]">Events</Link>
                    <Link onClick={closeMenu} to="/contactus" className="text-black hover:text-[#2F55D4]">Contact us</Link>
                </div>
            )}
        </div>
    );
};

export default Navbar;
